module.exports = __webpack_public_path__ + "imgs/leafwell-hero.de1d9bee2cb7b143ecc37cb534537539.svg";